/*
  cs-ga4-size-tracking.js

  Sends a GA4 `size_selected` event when a customer picks a size on a product page.
  Registered as a custom dimension in GA4 as: Selected Size / size_value (event-scoped).

  Notes for future maintainers:
  - Delegated listener on `document`, so it survives Shopify's variant re-render.
  - Radio inputs are named `{{ option.name }}-{{ option.position }}` by
    snippets/product-variant-options.liquid, which on this store renders as "Size-3"
    WITH A TRAILING NEWLINE. The prefix matcher below is deliberate — an exact
    [name="Size-3"] match would fail.
  - The select[name="options[Size]"] branch covers the drawer/dropdown picker used when
    an option exceeds pill_threshold. Inert on the pill layout, kept for safety.
  - Fires only on user interaction. Never on page load, never on a passive product view.
  - Does not load a second GA4 tag and never calls gtag('config'), so it cannot
    duplicate page_view. The gtag on this store is injected via content_for_header
    by the Google & YouTube channel (G-K2EW077TJE).
*/
document.addEventListener('change', function (event) {
  const element = event.target;

  const isSizeOption =
    element.matches('input[type="radio"][name^="Size-" i]') ||
    element.matches('select[name="options[Size]" i]');

  if (!isSizeOption) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };

  window.gtag('event', 'size_selected', {
    size_value: element.value
  });
});
